import Vue from 'vue'
import Dkmap from './Dkmap.vue'

import YmapPlugin from 'vue-yandex-maps'
Vue.use(YmapPlugin)

Vue.config.productionTip = false

if(document.getElementById("dkmap")){
  new Vue({
    render: h => h(Dkmap)
  }).$mount('#dkmap')
}



// WEBPACK FOOTER //
// ./src/main.js